import circlesStrings from 'modules/circles/strings';

import { Wrapper, AddClosedCircleBtn } from './ClosedCirclesHeader.style';

const ClosedCirclesHeader = () => (
  <Wrapper>
    <AddClosedCircleBtn as="button">
      {circlesStrings.closedCirclesHeader.addClosedCircleBtn}
    </AddClosedCircleBtn>
  </Wrapper>
);

export default ClosedCirclesHeader;
